// extracted by mini-css-extract-plugin
export default {"openingHoursGrid":"SiteInfoInPortal_openingHoursGrid__mT0Mj","openingHourCheckbox":"SiteInfoInPortal_openingHourCheckbox__zQd3-"};